export class BulkRestoreResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bulkRestoreGroup",
            "baseName": "bulkRestoreGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "jobs",
            "baseName": "jobs",
            "type": "Array<BulkRestoreResponseJobsInner>",
            "format": ""
        },
        {
            "name": "items",
            "baseName": "items",
            "type": "Array<BulkRestoreResponseItemsInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BulkRestoreResponse.attributeTypeMap;
    }
    constructor() {
    }
}
